module.exports = __webpack_public_path__ + "media/images/landing/avatar5-bff0798208ff5fdd0c5c228aa017b61b.jpg";